// @ts-check

import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { resetPasswordRequest } from "../api/user";

/**
 * A confirmation dialog for resetting the password. If email is undefined, it will
 * also have a field for the user to input their email.
 *
 * @param {{
 *  open: boolean;
 *  setOpen: (b: boolean) => void;
 *  email: string | undefined;
 *  username: string | undefined;
 * }} props
 */
export function ResetPasswordDialog(props) {
  const [email, setEmail] = useState(props.email || null);
  const [username, setUsername] = useState(props.username || null);
  const [resetSnackBarOpen, setResetSnackBarOpen] = useState(false);

  const onResetPassword = async () => {
    await resetPasswordRequest(email, username)
    props.setOpen(false)
    setResetSnackBarOpen(true)
  }

  const snackbarCloseAction = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => setResetSnackBarOpen(false)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const emailPreview = props.email ? ` (${props.email}) ` : ' '

  const usernamePreview = props.username ? `the password for ${props.username}` : 'your password'

  const isDisabled =
    email == null || email === "" || !email.includes("@")
    || username == null || username === "";

  return <>
    <Dialog
      open={props.open}
      onClose={() => props.setOpen(false)}
    >
      <DialogTitle>
        Reset password
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to reset {usernamePreview}? An email will be sent to your email address{emailPreview}containing a link to reset your password.
        </DialogContentText>

        {
          !props.username && <>
            <TextField
              label="Username"
              required
              id="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              sx={{ m: 1, marginTop: 2, width: "100%" }}
            />
          </>
        }

        {
          !props.email && <>
            <TextField
              label="Email"
              autoFocus
              required
              id="reset-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              sx={{ m: 1, marginTop: 2, width: "100%" }}
            />
          </>
        }

      </DialogContent>

      <DialogActions>
        <Button onClick={() => props.setOpen(false)}>Cancel</Button>
        <Button
          onClick={onResetPassword}
          disabled={isDisabled}
        >
          Send email
        </Button>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={resetSnackBarOpen}
      autoHideDuration={3000}
      onClose={() => setResetSnackBarOpen(false)}
      message="Password reset email sent"
      action={snackbarCloseAction}
    />
  </>
}